var map = {
	"./403.vue": [
		"./src/pages/403.vue",
		1,
		9
	],
	"./404.vue": [
		"./src/pages/404.vue",
		1,
		10
	],
	"./cock-fight.vue": [
		"./src/pages/cock-fight.vue",
		0
	],
	"./launch.vue": [
		"./src/pages/launch.vue",
		3
	],
	"./maintenance.vue": [
		"./src/pages/maintenance.vue",
		4
	],
	"./session-expired.vue": [
		"./src/pages/session-expired.vue",
		6
	],
	"./tai-xiu.vue": [
		"./src/pages/tai-xiu.vue",
		0,
		2
	],
	"./video-replay.vue": [
		"./src/pages/video-replay.vue",
		7
	],
	"./video.vue": [
		"./src/pages/video.vue",
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/pages lazy recursive ^\\.\\/.*\\.vue$";
module.exports = webpackAsyncContext;